import React from "react";
import PropTypes from "prop-types";

import { ConfirmationDropdown, useAssigneeOptions } from "..";

export function TaskAssigneeSelector({ initValue, users, onChange }) {
  const options = useAssigneeOptions(users);

  const unassigned = {
    key: "unassigned",
    value: "unassigned",
    text: "Unassigned",
    icon: "user circle outline",
  };

  const newUser = {
    key: "newuser",
    value: "newuser",
    text: "New User",
    icon: "user circle",
  };

  return (
    <ConfirmationDropdown
      data-test="task-assignee-dropdown"
      initValue={initValue}
      showSaveButton={false}
      onSelect={onChange}
      searchInput={{ autoFocus: false }}
      items={
        initValue === newUser.key
          ? [newUser, ...options, unassigned]
          : options.concat([unassigned])
      }
      style={{ maxWidth: "200px" }}
    />
  );
}

TaskAssigneeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  users: PropTypes.array,
  initValue: PropTypes.string,
};

TaskAssigneeSelector.defaultProps = {
  users: [],
  initValue: "unassigned",
};

export default TaskAssigneeSelector;
